import React, { useEffect, useState } from 'react';

import { CollapseAll, ExpandAll } from 'assets/assetsV1/iconComponents';

import { notNullOrUndefined } from 'constants/helper';

import { UserDataPersistenceService } from 'services/UserDataPersistenceService';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

export const ExpandCollapseAll = ({ gridRef, defaultExpandAll = true, onExpandCollapse = () => {} }) => {
  const [isExpandAllActive, setIsExpandAllActive] = useState(defaultExpandAll);

  /* read table key from gridRef?.current?.props?.gridStatePersistenceKey */
  const gridStatePersistenceKey = gridRef?.current?.props?.gridStatePersistenceKey;

  useEffect(() => {
    const checkAndUpdateExpandAllActive = async () => {
      const persistedGridState = await UserDataPersistenceService.get(gridStatePersistenceKey);
      if (persistedGridState) {
        const persistedExpandAllState = persistedGridState?.expandAll;
        if (notNullOrUndefined(persistedExpandAllState)) {
          setIsExpandAllActive(persistedExpandAllState);
          return;
        }
      }
      setIsExpandAllActive(defaultExpandAll);
    };
    checkAndUpdateExpandAllActive();
  }, [defaultExpandAll, gridStatePersistenceKey]);

  return (
    <>
      {isExpandAllActive ? (
        <Tooltip label="Collapse all">
          <Button
            StartIcon={CollapseAll}
            onClick={() => {
              setIsExpandAllActive(false);
              gridRef?.current?.api?.collapseAll();
              onExpandCollapse({ changedValue: 'Collapsed', prevValue: 'Expanded' });
            }}
            variant="tertiary"
          />
        </Tooltip>
      ) : (
        <Tooltip label="Expand all">
          <Button
            StartIcon={ExpandAll}
            onClick={() => {
              setIsExpandAllActive(true);
              gridRef?.current?.api?.expandAll();
              onExpandCollapse({ changedValue: 'Expanded', prevValue: 'Collapsed' });
            }}
            variant="tertiary"
          />
        </Tooltip>
      )}
    </>
  );
};
